module.exports = __webpack_public_path__ + "static/img/14.8220dca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/14.png
// module id = J/20
// module chunks = 0